import { render, staticRenderFns } from "./IncomeAndOutgoCropDetail.html?vue&type=template&id=971f4c5a&scoped=true&external"
import script from "./IncomeAndOutgoCropDetail.ts?vue&type=script&lang=ts&external"
export * from "./IncomeAndOutgoCropDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./IncomeAndOutgoCropDetail.css?vue&type=style&index=0&id=971f4c5a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971f4c5a",
  null
  
)

export default component.exports